
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.055 2.39c.093-.453.14-.77.14-.953 0-.218-.067-.372-.203-.46-.13-.089-.367-.138-.71-.149l.093-.406 1.977-.07h.453L2.46 5.766l.094.03c.49-.65.955-1.124 1.398-1.421.443-.297.893-.445 1.352-.445.49 0 .864.138 1.125.414.265.276.398.664.398 1.164 0 .328-.075.794-.226 1.398l-.508 2.047c-.14.568-.211.969-.211 1.203 0 .209.034.36.101.453.068.094.175.141.32.141.157 0 .324-.063.5-.188.178-.13.428-.374.75-.734l.446.438c-.422.437-.745.742-.969.914a2.051 2.051 0 01-1.344.469c-.338 0-.609-.12-.812-.36-.203-.245-.305-.555-.305-.93 0-.338.086-.836.258-1.492l.344-1.351c.125-.49.206-.852.242-1.086.042-.235.063-.425.063-.57 0-.365-.063-.626-.188-.782-.12-.156-.318-.234-.594-.234-.218 0-.46.088-.726.265-.26.177-.534.448-.82.813A6.37 6.37 0 002.46 6.96c-.167.328-.3.721-.398 1.18l-.711 3.382H0l2.055-9.132z","fill":"currentColor"}})])
          )
        }
      }
    